import React, { FC, useContext } from "react";
import I18nContext from "@I18n/Contexts/I18nContext";
import { IAnyLocalizedString } from "@types";

interface Props {
  localizedString: IAnyLocalizedString;
}

export const LocalizedMessage: FC<Props> = ({ localizedString }) => {
  const { locale } = useContext(I18nContext);

  const content = localizedString[locale] || localizedString.en;

  if (!content) return null;

  return (
    <span
      dangerouslySetInnerHTML={{
        __html: content,
      }}
    />
  );
};
